// src/pages/SuccessPage.jsx
import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAppContext } from '../../context/AppContext';
import { OnlineClubTrans, SuccessTrans, ToasterTrans } from '../../utils/translations';
import PayRub from "../../assets/images/pay1.png";
import PayShek from "../../assets/images/pay2.png";
import { v4 as uuidv4 } from 'uuid';
import { createAllPaySubscription, createYooKassaSubscription } from '../../services/paymentService';

export default function Subscribe() {
    const { user, language, setToaster, setLoading, onlineClubContent, token, premiumRoles } = useAppContext();
    const { loginWithRedirect } = useAuth0();

    // useEffect(() => {
    //     if (!user) {
    //         window.localStorage.setItem("redirectTo", "/subscribe");
    //         loginWithRedirect({ ui_locales: navigator.language || "ru" });
    //     }
        // if (premiumRoles.includes(user?.role)) {
        //     setToaster({
        //         message: ToasterTrans[language].alreadySubscribed,
        //         type: "success",
        //         show: true,
        //     })
        //     setTimeout(() => {
        //         window.location.assign("/")
        //     }, 4000);
        // };
    // }, [user])

    const handleAllPaySubscription = async (e) => {
        e.preventDefault();
        if (premiumRoles.includes(user?.role)) {
            setToaster({
                message: ToasterTrans[language].alreadySubscribed,
                type: "success",
                show: true,
            })
            setTimeout(() => {
                window.location.assign("/")
            }, 4000);
            return;
        };
        if (!user) {
            window.localStorage.setItem("redirectTo", "/subscribe");
            loginWithRedirect({ ui_locales: navigator.language || "ru" });
            return;
        }
        try {
            setLoading(true);
            const data = await createAllPaySubscription({
                orderId: uuidv4(),
                clientName: user.username,
                clientEmail: user.email,
                plan: "premium",
                successUrl: "https://www.onceuponamat.com/successfulPayment",
                backUrl: "https://www.onceuponamat.com",
                userId: user._id,
            }, token);
            if (data.payment_url) {
                setLoading(false);
                // redirect to Allpay
                window.location.assign(data.payment_url);
            };

        } catch (error) {
            console.error("Error subscribing", error);
            setLoading(false);
            setToaster({
                message: "Ошибка при оформлении подписки. Пожалуйста, попробуйте снова или напишите на anna.joy.inbox@gmail.com.",
                type: "error",
                show: true,
            });
        }
    };

    const handleYooKassaSubscription = async (e) => {
        e.preventDefault();
        if (premiumRoles.includes(user?.role)) {
            setToaster({
                message: ToasterTrans[language].alreadySubscribed,
                type: "success",
                show: true,
            })
            setTimeout(() => {
                window.location.assign("/")
            }, 4000);
            return;
        };
        if (!user) {
            window.localStorage.setItem("redirectTo", "/subscribe");
            loginWithRedirect({ ui_locales: navigator.language || "ru" });
            return;
        }
        try {
            setLoading(true);
            const data = await createYooKassaSubscription({
                plan: "premium",
                successUrl: "https://www.onceuponamat.com/successfulPayment",
                userId: user._id,
            }, token);
            if (data.payment_url) {
                setLoading(false);
                // redirect to Yookassa
                window.location.assign(data.payment_url);
            };

        } catch (error) {
            console.error("Error subscribing", error);
            setLoading(false);
            setToaster({
                message: "Ошибка при оформлении подписки. Пожалуйста, попробуйте снова или напишите на anna.joy.inbox@gmail.com.",
                type: "error",
                show: true,
            });
        }
    };

    return (
        <div className="w-full mx-auto my-12">
            <h1 className="md:mt-o mt-16 text-2xl md:text-3xl font-bold mb-8 text-center mx-4 md:mx-0">{SuccessTrans[language].registration}</h1>
            <div className="bg-white/70 p-4 rounded-md shadow-lg text-sm md:w-7/12 w-11/12 mx-auto">
                <p className="text-center mb-4">
                    {SuccessTrans[language].welcome2}
                </p>
                <p>{SuccessTrans[language].membership}</p>
            </div>

            {/* Что входит? */}
            <section className="bg-beige py-10 px-6 w-full mt-10">
                <h2 className="text-lg md:text-xl font-semibold  text-center">📦 {OnlineClubTrans[language].formats}</h2>
                <div className="text-base md:text-base font-semibold mb-6 text-center">{OnlineClubTrans[language].formatsDescrition}</div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-6xl mx-auto text-center">
                    {onlineClubContent.map((item, idx) => (
                        <div
                            key={idx}
                            className="relative group w-full h-80 [perspective:1000px] mx-auto"
                        >
                            <div className="relative w-full h-full transition-transform duration-700 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">

                                {/* Front Side */}
                                <div className="absolute inset-0 bg-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 [backface-visibility:hidden]">
                                    <img src={item.img} alt={item.title} className="rounded-full w-24 h-24 object-cover mb-4" />
                                    <h3 className="text-xl md:text-2xl font-semibold mb-2">{item.title}</h3>
                                    <p className="text-sm mb-4">{item.description}</p>

                                    {/* Subtle mobile-only pointer in top-right */}
                                    <div className="absolute bottom-4 right-5 text-xs text-black opacity-80 md:hidden pointer-events-none select-none">
                                        ⤷
                                    </div>
                                </div>

                                {/* Back Side */}
                                <div className="absolute inset-0 bg-brown text-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 [transform:rotateY(180deg)] [backface-visibility:hidden]">
                                    <h3 className="text-xl font-semibold mb-4 text-white">{item.title}</h3>
                                    <p className="text-sm text-white">{item.extra}</p>
                                    {item.link && language === "russian" ? <a href={item.link} className="border border-darkBrown px-4 py-2 mt-5 rounded-full hover:bg-beige hover:text-black transition text-sm">
                                        {item.button}
                                    </a> : <button className="border border-darkBrown px-4 py-2 mt-5 rounded-full hover:bg-beige hover:text-black transition text-sm" onClick={() => {
                                        setToaster({
                                            message: ToasterTrans[language].comingSoon,
                                            type: "info",
                                            show: true,
                                        });
                                    }}>{item.button}</button>}
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="mb-4 md:w-11/12 mx-auto">
                <section className="py-8 px-6 h-fit">
                    <h2 className="text-lg md:text-xl font-semibold text-center mb-4">{SuccessTrans[language].dust} ✈️</h2>
                    <div className="grid grid-cols-2 md:gap-8 gap-5 md:max-w-3xl mx-auto text-center">
                        {[
                            {
                                title: SuccessTrans[language].interCard,
                                description: SuccessTrans[language].liveLessonsDescription,
                                extra: SuccessTrans[language].liveLessonsExtra,
                                img: PayRub,
                                button: SuccessTrans[language].liveLessonsButton,
                                link: "https://allpay.to/~onceuponamat/once-up-on-a-mat-online-club",
                                action: handleAllPaySubscription,
                            },
                            {
                                title: SuccessTrans[language].rusCard,
                                description: OnlineClubTrans[language].libraryDescription,
                                extra: OnlineClubTrans[language].libraryExtra,
                                img: PayShek,
                                button: SuccessTrans[language].libraryButton,
                                link: "/library",
                                action: handleYooKassaSubscription,
                            },
                        ].map((item, idx) => (
                            <button
                                onClick={item.action}
                                key={idx}
                                className="bg-white/70 md:py-10 py-5 hover:bg-white rounded-2xl p-3 text-center transition-all duration-500 ease-in-out transform hover:-translate-y-2 hover:shadow-xl items-center justify-center"
                            >
                                <img src={item.img} alt={item.title} className="rounded-full w-24 h-24 object-cover mb-4 mx-auto" />
                                <h3 className="text-sm md:text-lg font-semibold text-center">{item.title}</h3>
                            </button>
                        ))}
                    </div>
                </section>
            </section>
        </div>
    );
}
